export const ActionTypes = {
  getAllJobs: "getAllJobs",
  getJob: "getJob",
  updateJob: "updateJob",
}
